<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-card width="100%">
      <v-row no-gutters align="center" class="mt-5">
        <v-col cols="8" class="d-flex">
          <span>조직차수 : {{ updateOrgnVer ? updateOrgnVer : '-' }}</span>
          <span style="margin-left: 100px">생성날짜 : {{ createdDate ? createdDate : '-' }}</span>
          <span style="margin-left: 100px">{{ IsLastVersion == true ? '확정일자 : ' + confirmDate : '' }}</span>
        </v-col>
      </v-row>

      <!-- 메인 컨텐츠 -->
      <div id="container" class="mt-3">
        <DxDiagram
          id="diagram"
          ref="dxDiagram"
          :key="'risk-orgn-dgm-' + (selectedOrgnVersion || 'none')"
          class="layout-col-height03"
          custom-shape-template="CustomShapeTemplate"
          :custom-shapes="diagramCustomShapes"
          @request-layout-update="onRequestLayoutUpdate"
          @custom-command="onCustomCommand"
          @requestLayoutUpdate="onItemUpdated"
          :auto-zoom-mode="'disabled'"
          :simple-view="false"
          :read-only="mode"
        >
          <DxZoomLevel :value="0.75" :items="['0.5', '0.75', '1', '1.5']" />
          <template #CustomShapeTemplate="{ data }">
            <CustomShapeTemplate v-if="data && data.dataItem" :employee="data.dataItem" :riskHr="riskHr" :delete-employee="deleteEmployee" />
          </template>
          <DxNodes
            :data-source="getRiskDetailDatasource"
            :key-expr="'id'"
            :type-expr="'type'"
            :custom-data-expr="itemCustomDataExpr"
            :text-style-expr="textStyleExpr"
            :parent-key-expr="'headId'"
            :css-class="'tooltip'"
          >
            <DxAutoLayout :type="'tree'" />
          </DxNodes>
          <DxEdges :style-expr="styleExpr" :from-line-end-expr="'none'" :to-line-end-expr="'none'" />
          <DxContextToolbox :shape-icons-per-row="1" :width="200" />
          <DxToolbox :show-search="true" :shape-icons-per-row="1" :width="220" :visible="true" css-class="DxtoolBox">
            <DxGroup
              v-for="item in grpAuthList"
              :category="item.grpAuthCd"
              :key="item.grpAuthCd"
              :title="item.grpAuthNm"
              :display-mode="'texts'"
              :expanded="true"
            />
          </DxToolbox>
          <DxPropertiesPanel>
            <DxTab>
              <DxGroup :title="'Page Properties'" :commands="['pageSize', 'pageOrientation', 'pageColor']" />
            </DxTab>
          </DxPropertiesPanel>
        </DxDiagram>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import ArrayStore from 'devextreme/data/array_store'
import BaseDiagram from '@/views/base/BaseDiagram.vue'
import baseview from '@/views/base/baseview.vue'
import CustomShapeTemplate from '@/components/organization/CustomShapeTemplate.vue'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
//function
import {
  getRiskGrpAuth,
  getHumanResourceByRiskAsse,
  getRiskOrgnManageDetail, //위험성평가 조직 디테일
  getRiskOrgnManageMaster, //위험성평가 조직 마스터
  saveRiskOrgnManageDetail,
  saveRiskOrgnManageMaster,
  checkRiskOrgn,
  checkCopyRiskOrgnManage,
  copyRiskOrgnManage,
} from '@/api/riskAssessment/riskOrgnManage'

import { getHumanResources } from '@/api/component/component'
import { getAuthClientList } from '@/api/setting/clientManage'
import _ from 'lodash'
export default {
  mixins: [baseview, BaseDiagram],
  name: 'RiskOrgnDetailDiagram',
  components: { CustomShapeTemplate },
  props: {},
  data() {
    return {
      initCompId: '',
      dxDiagramRef: 'dxDiagram',
      selectOrgnVerList: [], //[{ OrgnVerCd: '2022-04-01' }, { OrgnVerCd: '2022-04-02' }, { OrgnVerCd: '2022-04-03' }],
      buttonOrgnUseList: [
        'btnEdit', //수정
        'btnCopy', //복사
        'btnSave', //저장
      ],
      detailDatasource: [],
      dataSource: new ArrayStore({
        key: 'id',
        data: [],
        onInserting(values) {
          values.esgHrNo = values.type.replace('employee', '')
        },
      }),
      riskHr: [
        // { esgHrNo: '2', korNm: '임윤주', jbrp: 'B12', jbrpNm: '차장', riskAssRole: 'B10', riskAssRoleNm: '위험성평가 담당자' },
      ],
      grpAuthList: [{ grpAuthCd: '', grpAuthNm: '' }],
      saveOrgnResultData: [],
      selectedOrgnVersion: '',
      selectedRow: undefined,
      mode: true,
      applyFlag: false,
      authClientList: [],
    }
  },
  computed: {
    updateOrgnVer: {
      get() {
        return this.selectedOrgnVersion
      },
      set(value) {
        this.selectedOrgnVersion = `${value}`
      },
    },
    getZoomLevel() {
      return this.zoomLebel
    },
    getOrgnVerList() {
      return this.selectOrgnVerList
    },
    createdDate() {
      return this.selectedRow == undefined || this.selectedRow.createdAt == undefined ? '' : this.yyyyMMdd(this.selectedRow.createdAt)
    },
    confirmDate() {
      var returnValue = '미확정'
      var selItem = this.selectOrgnVerList.find((x) => x.OrgnVerCd == this.selectedOrgnVersion)
      var confirmYn = selItem != undefined && selItem.confirmYn != undefined ? selItem.confirmYn : false
      if (confirmYn == true) returnValue = this.yyyyMMdd(this.selectOrgnVerList.find((x) => x.OrgnVerCd == this.selectedOrgnVersion).confirmDt)

      return returnValue
    },
    // DxCustomShape v-for는 Diagram(비동기 템플릿)과 Vue 패치가 충돌해 insertBefore 오류가 날 수 있음 → customShapes 배열만 전달
    diagramCustomShapes() {
      const list = Array.isArray(this.riskHr) ? this.riskHr : []
      return list.map((employee) => ({
        type: 'employee' + employee.esgHrNo,
        category: employee.grpAuthCd,
        baseType: 'rectangle',
        title: 'New Employee',
        defaultWidth: 1.8,
        defaultHeight: 1,
        toolboxWidthToHeightRatio: 2,
        defaultText: this.getCustomShapeDefaultText(employee),
        allowEditText: false,
        minWidth: 1.8,
        minHeight: 1,
        maxWidth: 1.8,
        maxHeight: 1,
      }))
    },
    // 그려진 다이어그램 (참조 고정 — computed 안에서 ArrayStore를 매번 새로 만들면 Diagram DOM과 Vue 패치가 충돌할 수 있음)
    getRiskDetailDatasource() {
      return this.dataSource
    },
    getRiskOrgnList() {
      return this.grpAuthList
    },
    //최신차수 인지 아닌지?
    IsLastVersion() {
      return this.highestOrgnVersion && this.highestOrgnVersion.OrgnVerCd == this.updateOrgnVer
    },
    highestOrgnVersion() {
      if (this.selectOrgnVerList.length == 0) return
      return this.selectOrgnVerList.reduce((a, b) => (a.OrgnVerCd > b.OrgnVerCd ? a : b))
    },
  },
  watch: {
    // 배열 참조가 바뀔 때만 스토어 재구성 (computed에서 매번 새로 만들면 insertBefore 오류가 날 수 있음)
    detailDatasource(newVal) {
      this.dataSource = new ArrayStore({
        key: 'id',
        data: Array.isArray(newVal) ? newVal.slice() : [],
        onInserting(values) {
          values.esgHrNo = values.type.replace('employee', '')
        },
      })
    },
  },
  created() {
    this.$EventBus.$on('clickTab', (param) => {
      console.log('조직도 이벤트 수신 clickTab', param)

      this.selectedRow = param
      this.selectedOrgnVersion = this.selectedRow.orgnOrder
      this.applyFlag = this.selectedRow.applyFlag
      this.mode = true
      if (this.selectedOrgnVersion.startsWith('insert-') == false) this.btnSearch()
      else this.vToastify('차수 정보를 저장해주세요', 'warn')
    })

    this.$EventBus.$on('moveToTabPage', (param) => {
      console.log('moveToTapPage', param)
      this.selectedRow = param
      this.selectedOrgnVersion = this.selectedRow.orgnOrder
      this.applyFlag = this.selectedRow.applyFlag
      this.mode = true
      this.btnSearch()
      this.zoomLebel = 0.75
    })
    this.$EventBus.$on('OnsaveAndDeleteMaster', (param) => {
      //컴포넌트를 위한 조직 버전 리스트 조회
      this.btnSearch(false)
    })
  },

  beforeMount() {
    //console.log('beforeMount')
    this.diagramRfs = [this.dxDiagramRef]
    //커스텀 Shape를 위한 역할 그룹 조회
    getAuthClientList({ clntId: this.getClntId() }).then((res) => {
      this.authClientList = res.list
    })
    Promise.all([getRiskGrpAuth()])
      .then((response) => {
        let failedResponse = response.find((element) => !element.success)
        if (failedResponse == null) {
          this.grpAuthList = response[0].list.slice()
          // this.grpAuthList = response[0].list.slice().map(item => ({
          //   ...item,
          // }))
          // this.grpAuthList.unshift({ grpAuthCd: 'all', grpAuthNm: '전체' })
        }
      })
      .catch((error) => {})
    //조직구성도 다이아그램 정보 조회
  },
  mounted() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    //컴포넌트를 위한 조직 버전 리스트 조회
    // this.btnSearch()
  },
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      const toRouter = {
        name: 'RiskOrgnManage',
        params: {
          search: true,
        },
      }
      this.$router.push(toRouter)
    }
  },
  updated() {},
  methods: {
    yyyyMMdd: function (value) {
      // 들어오는 value 값이 공백이면 그냥 공백으로 돌려줌
      if (value == '') return ''

      // 현재 Date 혹은 DateTime 데이터를 javaScript date 타입화
      var js_date = new Date(value)

      // 연도, 월, 일 추출
      var year = js_date.getFullYear()
      var month = js_date.getMonth() + 1
      var day = js_date.getDate()

      // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
      if (month < 10) {
        month = '0' + month
      }

      if (day < 10) {
        day = '0' + day
      }

      // 최종 포맷 (ex - '2021-10-08')
      return year + '-' + month + '-' + day
    },

    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //최종차수 조직 구성도 복사
    btnCopy() {
      //최신 차수가 아니면 복사 X
      //확정된 차수가 아니면 복사 x
      let param = {
        clntId: this.getClntId(),
        compId: this.comp.id,
        orgnOrder: this.selectedOrgnVersion,
      }

      checkCopyRiskOrgnManage(param, false)
        .then((response) => {
          if (response.success) {
            this.vToastifyPrompt(
              `복사하여 차수를 생성하시겠습니까?`,
              'info',
              (current) => {
                this.openLoading('copying')
                //복사 처리
                copyRiskOrgnManage(param, true)
                  .then((res) => {
                    if (res.success) {
                      this.selectedTab = '0'
                      this.$emit('moveToTabPage', this.selectedOrgnVersion, this.selectedTab)
                    }
                  })
                  .catch((error) => {
                    if (error.response && error.response.data) {
                      if ([-6034, -6035].includes(error.response.data.code)) {
                        this.vSnackbar(`${this.selectedOrgnVersion}> ${error.response.data.msg}`, 'warn')
                      }
                    }
                  })
                  .finally(() => {
                    this.endLoading()
                  })
              },
              null,
              true
            )
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if ([-6034, -6035].includes(error.response.data.code)) {
              this.vSnackbar(`${this.selectedOrgnVersion}> ${error.response.data.msg}`, 'warn')
            }
          }
        })

      /*
      var fromOrgnVersion = this.selectedOrgnVersion
      var toOrgnVersion = ''
      var toOrgnConfirmYn = false
      //console.log(this.selectOrgnVerList)
      if (this.selectOrgnVerList.length > 0) {
        toOrgnVersion = this.selectOrgnVerList[this.selectOrgnVerList.length - 1].OrgnVerCd
        toOrgnConfirmYn = this.selectOrgnVerList[this.selectOrgnVerList.length - 1].confirmYn
      }
      if (fromOrgnVersion == toOrgnVersion) {
        this.vSnackbar(fromOrgnVersion + ' > 최근 차수는 복사할 수 없습니다.', 'warn')
        return
      } else if (toOrgnConfirmYn == true) {
        this.vSnackbar(toOrgnVersion + ' > 확정된 차수는 복사할 수 없습니다.', 'warn')
        return
      } else this.saveOrganization(fromOrgnVersion + ' -> ' + toOrgnVersion + '<br> 복사하시겠습니까?', true, toOrgnVersion)
      */
    },
    //조직구성도 트리 저장하기
    btnSave() {
      this.saveOrganization()
    },
    saveOrganization(message, bCopy, bCopyOrgnVer) {
      //유효성 체크
      //확정여부 조회
      this.saveOrgnResultData = []

      if (this.dataSource._array.length > 0) {
        this.getRiskDetailDatasource._array.some((x) => {
          if (bCopy == true) x.orgnOrder = bCopyOrgnVer
          else x.orgnOrder = this.selectedOrgnVersion

          if (x.compId == undefined) x.compId = this.comp.id

          this.saveOrgnResultData.push({
            id: x.id,
            clntId: this.getClntId(),
            compId: x.compId,
            orgnOrder: x.orgnOrder,
            esgHrNo: x.esgHrNo,
            grpAuthCd: x.grpAuthCd,
            headId: x.headId,
            createdBy: this.getUserCd(),
          })
        })
      } else {
        //차수가 하나도 없으면 그냥 데이타 내용을 삭제하라
        this.saveOrgnResultData.push({
          clntId: this.getClntId(),
          compId: this.comp.id,
          orgnOrder: bCopy == true ? bCopyOrgnVer : this.selectedOrgnVersion,
        })
      }
      console.log('@@@@@@@@@@@@@@@saveOrgnResultData', this.saveOrgnResultData)
      //DB에 저장
      this.vToastifyPrompt(
        message == undefined ? '조직구성도를 저장하시겠습니까?' : message,
        'info',
        (current) => {
          this.openLoading()
          if (this.selectedOrgnVersion != undefined && this.selectedOrgnVersion.startsWith('insert-') == true) {
            saveRiskOrgnManageMaster(this.selectedRow, true)
              .then((res) => {
                if (res.success) {
                  this.saveDetail()
                }
              })
              .catch((error) => {
                if (error.response && error.response.data) {
                  if ([-6029, -6030, -6032].includes(error.response.data.code)) {
                    this.vSnackbar(`${bCopy == true ? bCopyOrgnVer : this.selectedOrgnVersion}> ${error.response.data.msg}`, 'warn')
                  }
                }
              })
              .finally(() => {
                this.endLoading()
                return true
              })
          } else {
            this.saveDetail()
          }
        },
        null,
        true
      )
    },
    async btnEdit() {
      let param = {
        clntId: this.getClntId(),
        compId: this.comp.id,
        orgnOrder: this.selectedOrgnVersion,
      }
      checkRiskOrgn(param, false)
        .then((response) => {
          if (response.success) {
            getHumanResources(param, false)
              .then((res) => {
                this.riskHr = res.list
                // this.searchDetailData()
              })
              .catch((error) => {
                this.endLoading()
              })
              .finally(() => {
                this.$nextTick(() => {
                  this.mode = !this.mode
                })
              })
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if ([-6029, -6030, -6032].includes(error.response.data.code)) {
              this.vSnackbar(`${this.selectedOrgnVersion}> ${error.response.data.msg}`, 'warn')
            }
          }
        })
    },
    saveDetail() {
      saveRiskOrgnManageDetail(this.saveOrgnResultData, true)
        .then((res) => {
          if (res.success) {
            this.btnSearch()
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if ([-6029, -6030, -6032].includes(error.response.data.code)) {
              this.vSnackbar(`${this.selectedOrgnVersion}> ${error.response.data.msg}`, 'warn')
            }
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //조직 구성도 조회
    searchDetailData(bNotify) {
      // 조회 직전에 빈 배열로 두 번(ArrayStore 재생성) 갱신하면 Diagram 내부 DOM과 Vue 패치가 충돌할 수 있음
      bNotify = bNotify == undefined ? true : bNotify
      if (this.comp == undefined) this.vSnackbar('필수조회조건이 없습니다.(compId)', 'warn')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        orgnOrder: this.selectedOrgnVersion,
      }
      this.openLoading('searching')
      getRiskOrgnManageDetail(params, bNotify)
        .then((res) => {
          if (res.success) {
            this.detailDatasource = res.list || []
            // toolbox 수정(?)
            //this.setToolBoxData(params)
          }
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //조직 차수 리스트 조회(콤보박스)
    btnSearch(bUse, orgnOrder) {
      // riskHr를 먼저 비우면 DxCustomShape v-for가 한꺼번에 사라져 DxDiagram(DevExtreme)이 잡은 DOM과
      // Vue의 insertBefore 패치가 충돌하는 경우가 많음. 새 데이터 수신 시에만 목록을 교체한다.
      if (bUse == undefined) bUse = true
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        // orgnOrder: this.selectedOrgnVersion
      }
      this.openLoading('searching')
      console.log('getRiskOrgnManageMaster start')

      this.selectOrgnVerList = []
      getRiskOrgnManageMaster(params, false)
        .then((res) => {
          if (res.success) {
            res.list.forEach((element) => {
              this.selectOrgnVerList.push({
                OrgnVerCd: element.orgnOrder,
                confirmYn: element.confirmYn == 'Y' ? true : false,
                confirmDt: element.confirmDt,
                createdAt: element.createdAt,
              })
            })
            //휴먼 리소스 조회하여 툴박수 구성
            if (bUse) {
              console.log('getHumanResourceByRiskAsse start')
              this.setToolBoxData(params)
            }
          }
        })
        .catch((error) => {
          this.endLoading()
        })
        .finally(() => {})
    },
    setToolBoxData(params) {
      params.grpAuthCd = 'all'
      params.type = 'risk'
      getHumanResources(params, false).then((res) => {
        this.riskHr = res.list
        this.searchDetailData()
      })
      // getHumanResourceByRiskAsse(params, false)
      //   .then((res) => {
      //     if (res.success) {
      //       console.log('인원정보 조회', res)
      //       // this.riskHr = res.list.filter(el => this.authClientList.some(item => item.clntId == el.clntId))
      //       this.riskHr = res.list
      //       this.searchDetailData()
      //     }
      //   })
      //   .catch((error) => {
      //     this.endLoading()
      //   })
      //   .finally(() => {})
      this.endLoading()
    },
    //------------------------------------------

    ///////////////////////////////////////
    /*        ETC Event Event       */
    ///////////////////////////////////////
    itemCustomDataExpr(obj, value) {
      if (value === undefined) {
        return {
          korNm: obj.korNm,
          orgnOrder: obj.orgnOrder,
          clntId: obj.clntId,
          grpAuthNm: obj.grpAuthNm,
        }
      }
      // obj.korNm = value.korNm
      obj.orgnOrder = value.orgnOrder
      obj.clntId = value.clntId
      obj.esgHrNo = value.esgHrNo
      obj.headId = value.headId
      obj.id = value.id

      return obj
    },
    textStyleExpr(obj) {
      return 'visibility:hidden'
    },
    styleExpr(obj) {
      console.log('styleExpr', obj)
      return 'stroke: gray'
    },
    linkFromLineEndExpr() {
      return 'none'
    },
    linkToLineEndExpr() {
      return 'none'
    },
    onRequestLayoutUpdate(e) {
      //console.log('onRequestLayoutUpdate')

      for (let i = 0; i < e.changes.length; i += 1) {
        if (e.changes[i].type === 'remove') {
          e.allowed = true
        } else if (e.changes[i].data.headId !== undefined && e.changes[i].data.headId !== null) {
          e.allowed = true
        }
      }
    },

    deleteEmployee(employee) {
      this.vToastifyPrompt(
        message == undefined ? '조직구성도를 저장하시겠습니까?' : message,
        'info',
        (current) => {
          let tab2 = current.$refs['RiskOrgnDetailDiagram']
          this.dataSource.push([{ type: 'remove', key: employee.id }])
        },
        null,
        false
      )
    },
    //
    onCustomCommand(e) {
      if (e.name === 'clear') {
        const result = dialog.confirm('Are you sure you want to clear the diagram? This action cannot be undone.', 'Warning')
        result.then((dialogResult) => {
          if (dialogResult) {
            e.component.import('')
          }
        })
      }
    },
    getCustomShapeDefaultText(employee) {
      let defaultText = ''
      let exist = ''

      if (employee.sabun == undefined || employee.sabun == null || employee.sabun == '') {
        defaultText = employee.korNm
      } else {
        defaultText = employee.korNm + '(' + employee.sabun + ')'
      }

      if (employee.hrDelYn == 'Y') {
        exist = '(없음)'
      }

      return defaultText + exist //ex:이름(사번)(없음)
    },
    onDiagramError(e) {
      console.log('onDiagramError', e)
    },
    // toolbox에서 드래그 앤 드롭으로 shape 추가 시 발생하는 이벤트
    onItemUpdated(e) {},
  },
  beforeDestroy() {
    this.$EventBus.$off('clickTab')
    this.$EventBus.$off('moveToTabPage')
    this.$EventBus.$off('OnsaveAndDeleteMaster')
  },
}
</script>
<style lang="scss" scoped>
::v-deep .menuable__content__active {
  z-index: 1600 !important;
}
//
// #diagram {
//   height: 725px;
// }

.dx-popup-content {
  padding: 0;
}

.dx-popup-content .dx-fieldset.buttons {
  display: flex;
  justify-content: flex-end;
}

.dx-popup-content .dx-fieldset.buttons > * {
  margin-left: 8px;
}

::v-deep .menuable__content__active {
  z-index: 2000 !important ;
}

// ::v-deep .dx-accordion-item-opened > .dx-accordion-item-body {
//   display: none !important;
// }

::v-deep #diagram > .dx-diagram-floating-toolbar-container {
  left: 700px !important;
}

.displayNone {
  .dx-accordion-item-opened > .dx-accordion-item-body {
    display: none !important;
  }
}
</style>
